import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class CompletedDate extends Field {
  static attributesForModel() {
    return ['completedDate'];
  }

  get title() {
    return 'Completed date';
  }

  exampleContents(): FieldContentsData {
    return {
      text: dateFormattedWithUserLocale(moment().add(3, 'months')),
      icon: { name: 'fa-regular fa-calendar-lines' },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.completedDate) {
      return {
        text: dateFormattedWithUserLocale(record.completedDate),
        icon: { name: 'fa-regular fa-calendar-lines' },
      };
    }

    return {};
  }
}
